import { render, staticRenderFns } from "./PhotoSidebarMenu.vue?vue&type=template&id=2d36b92a&scoped=true&"
import script from "./PhotoSidebarMenu.vue?vue&type=script&lang=js&"
export * from "./PhotoSidebarMenu.vue?vue&type=script&lang=js&"
import style0 from "./PhotoSidebarMenu.vue?vue&type=style&index=0&id=2d36b92a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d36b92a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d36b92a')) {
      api.createRecord('2d36b92a', component.options)
    } else {
      api.reload('2d36b92a', component.options)
    }
    module.hot.accept("./PhotoSidebarMenu.vue?vue&type=template&id=2d36b92a&scoped=true&", function () {
      api.rerender('2d36b92a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Sidebar/SidebarComponents/PhotoSidebarMenu.vue"
export default component.exports